import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Raw hair vs Virgin hair?",
      answer:
        "Raw Hair\n• 100% unprocessed human hair. No chemicals, no steam, no dyes, no silicone coatings.\n• Cut directly from a donor and kept in its natural state\n• Cuticles are fully intact and aligned\n• Has natural variation in texture and colour\n• Reacts to colouring exactly like natural hair\n• Longest lifespan (often 3–5+ years with proper care)\n\nBest for:\nClients who want luxury hair, long-term wear, repeated colouring, or very natural results.\n\nVirgin Hair\n• Human hair that has not been chemically processed, but has been altered for uniformity.\n• May be steam-processed to create curls or waves\n• Often colour-corrected lightly (still considered virgin)\n• Texture is more consistent across bundles\n• Shorter lifespan than raw hair\n• Still good quality, but not completely untouched\n\nBest for:\nClients who want good-quality hair at a more accessible price point with predictable texture."
    },
    {
      question: "What are micro-links / I-tip installations?",
      answer:
        "Micro-links (or I-tips) are small hair extensions attached strand by strand using tiny beads or rings — no glue or thread needed."
    },
    {
      question: "What is a braid-less sew-in?",
      answer:
        "A braid-less sew-in uses micro-beads to create a secure base, allowing wefts to be sewn in without traditional braids. It gives a more natural, flexible finish."
    },
    
    {
      question: "Hybrid vs traditional sew-ins?",
      answer:
        "Hybrid sew-ins mix techniques — usually part braid-less and part braided — for a flatter, more versatile look and a lot more hair is usually left out to cover tracks. Traditional sew-ins are fully braided before sewing the weft extensions."
    },
    {
      question: "How long does a sew-in last?",
      answer:
        "With proper care, a sew-in can last 6–8 weeks before needing a reinstall or maintenance."
    },
    {
      question: "Can I reuse my extensions?",
      answer:
        "Yes, especially if you're using raw or high-quality hair — it can last up to 2 years with proper care. Tape-ins and micro links would need to be replaced depending on the condition."
    },
    {
      question: "How should I care for my extensions?",
      answer:
        "Use sulfate-free shampoo, keep the hair moisturized, and avoid heavy oils near the roots. Regular brushing and wrapping at night helps maintain the style."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      className="py-4"
      style={{
        background:
          'linear-gradient(180deg, #fcfcf9 70%, #f5f3ed 100%)'
      }}
    >
      <div className="container position-relative">
        <div className="text-center mb-3">
          <span
            className="badge rounded-pill px-3 py-1 mb-1"
            style={{
              background: '#ffffff',
              color: '#8b7355',
              letterSpacing: '.08em',
              fontWeight: 600,
              fontSize: '.96rem',
              border: '1.1px solid #d4c4a8'
            }}
          >
            Got Questions?
          </span>
          <h2
            className="fw-bold"
            style={{
              fontFamily: "'Playfair Display', serif",
              color: '#3a3a3a',
              letterSpacing: '.02em',
              margin: '0.25em 0',
              fontSize: '1.12rem'
            }}
          >
            Frequently Asked Questions
          </h2>
          <p
            className="text-muted mx-auto mb-1"
            style={{ maxWidth: 400, fontSize: '.95em' }}
          >
            Everything you need to know about our premium hair extensions and
            professional services
          </p>
        </div>
        {/* FAQ */}
        <div className="mx-auto my-2" style={{ maxWidth: 530 }}>
          {faqs.map((faq, index) => (
            <div
              className="card border-0 shadow-sm mb-2"
              style={{
                borderRadius: '1em',
                overflow: 'hidden',
                background: '#fff',
                boxShadow:
                  openIndex === index
                    ? '0 5px 16px #ccb98f32'
                    : '0 1px 3px #c5b48613',
                transition: 'box-shadow 0.18s'
              }}
              key={index}
            >
              <button
                className="card-header bg-transparent border-0 d-flex align-items-center justify-content-between"
                style={{
                  cursor: 'pointer',
                  minHeight: 46,
                  padding: '14px 17px',
                  background:
                    openIndex === index
                      ? 'linear-gradient(89deg, #f8e6bb 80%, #f5f1eb 100%)'
                      : 'transparent',
                  borderRadius: '1em 1em 0 0'
                }}
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-collapse-${index}`}
              >
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: '.99em',
                    color: openIndex === index ? '#2c2c2c' : '#252525'
                  }}
                >
                  {faq.question}
                </span>
                <span
                  className="d-inline-flex align-items-center justify-content-center"
                  style={{
                    transition: 'transform 0.19s',
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    background:
                      openIndex === index ? '#d4c4a8' : '#f8e6bb',
                    transform:
                      openIndex === index
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)'
                  }}
                  aria-hidden="true"
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M4 6L8 10L12 6"
                      stroke={openIndex === index ? '#fff' : '#8b7355'}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
              {/* Answer */}
              <div
                id={`faq-collapse-${index}`}
                className="collapse"
                style={{
                  display: openIndex === index ? 'block' : 'none'
                }}
              >
                <div
                  className="card-body py-2 px-3 text-secondary"
                  style={{
                    fontSize: '.96em',
                    fontWeight: 500,
                    whiteSpace: 'pre-line'
                  }}
                >
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* CTA */}
        <div
          className="text-center mt-3 p-3"
          style={{
            background:
              'radial-gradient(ellipse at right bottom, #f7ecd2 0%, #fff8ea 80%)',
            borderRadius: 16,
            boxShadow: '0 2px 8px #e0c78b28',
            border: '1px solid #f0e1b9'
          }}
        >
          <h3
            className="mb-2 fs-5 fw-bold"
            style={{
              color: '#3a3a3a',
              fontFamily: "'Playfair Display',serif"
            }}
          >
            Still Have Questions?
          </h3>
          <p
            className="mb-3 text-muted"
            style={{ maxWidth: 400, margin: '0 auto', fontSize: '.96em' }}
          >
            Our team is here to help you find the perfect hair solution. Reach
            out anytime.
          </p>
          <div className="d-flex flex-wrap justify-content-center gap-2">
            <a
              href="https://wa.me/27817392001"
              className="btn d-inline-flex align-items-center gap-2 fw-bold rounded-pill shadow border-0"
              style={{
                background:
                  'linear-gradient(90deg,#25D366,#128C7E)',
                color: '#fff',
                fontSize: '.97em',
                padding: '9px 22px'
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i
                className="bi bi-whatsapp"
                style={{ fontSize: '1.12em' }}
              ></i>
              WhatsApp Us
            </a>
            <a
              href="tel:+27817392001"
              className="btn d-inline-flex align-items-center gap-2 fw-bold rounded-pill shadow border-0"
              style={{
                background:
                  'linear-gradient(90deg,#d4c4a8,#c4a15a)',
                color: '#232323',
                fontSize: '.97em',
                padding: '9px 22px'
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-telephone"></i>
              Call Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
